import React, { useState } from 'react';
import DropZone from './SingleImageDropzone';

const changeImageVersion = (url) => {
  if (!url) {
    return '';
  }
  return url.replace('unmodified', 'square');
};

const ProfilePhotoUpload = ({
  photoButtonUrl,
  profileData,
  subDir,
  uploadSession,
}) => {
  const [error, setError] = useState('');
  const [photoUrl, setPhotoUrl] = useState(
    changeImageVersion(profileData.profile_photo?.url),
  );
  const [photoClass, setPhotoClass] = useState('');

  const onError = (file, errorMessage) => {
    setError(errorMessage);
  };

  const photoUploaded = (response) => {
    console.log(response);
    if (response.success) {
      setPhotoUrl(response.photo.square_url);
      setPhotoClass('photo-updated');
    }
    if (!response.success) {
      setError(response.response);
    }
  };

  const setDropzoneParams = () => {
    const dropzoneParams = {
      format: 'json',
      function: 'upload',
      upload_session: uploadSession,
    };
    return dropzoneParams;
  };

  return (
    <fieldset className="form-group form-group--no-validation form-group--photo">
      <legend className="form-group__title">Your profile photo</legend>
      <div className="photo-placeholder">
        {photoUrl ? (
          <img
            id="profilePhoto"
            className={photoClass}
            src={photoUrl}
            width="60px"
            height="60px"
            alt="Your profile photo"
          />
        ) : (
          <span className="photo-placeholder__icon" aria-hidden="true">
            <i className="far fa-user"></i>
          </span>
        )}
      </div>
      {photoButtonUrl ? (
        <a
          type="button"
          href={photoButtonUrl}
          className="button button--secondary"
        >
          {photoUrl ? 'Update photo' : 'Add photo'}
        </a>
      ) : (
        <>
          <DropZone
            uploadUrl={`/${subDir}/upload-photos.pl`}
            slotsRemaining={1}
            onSuccess={photoUploaded}
            onError={onError}
            dzParams={setDropzoneParams()}
            maxFileSize="16777216"
          />
          <p className="form-group__date-error" aria-live="assertive">
            {error}
          </p>
        </>
      )}
    </fieldset>
  );
};

export default ProfilePhotoUpload;
